import React from 'react';

import { Typography } from 'antd';

import LegendDot from '../LegendDot';
import styles from './styles.module.less';

const { Text } = Typography;

export interface SeriesTotalItem {
  key: string;
  label: string;
  color: string;
  total: number;
}

/** Inline legend showing each series with its total for the period. */
const SeriesTotals: React.FC<{ items: SeriesTotalItem[] }> = ({ items }) => (
  <div className={styles.totals}>
    {items.map(item => (
      <div className={styles.total} key={item.key}>
        <LegendDot color={item.color} />
        <Text type="secondary">{item.label}</Text>
        <Text strong>{item.total}</Text>
      </div>
    ))}
  </div>
);

export default SeriesTotals;
